/**
 * ⚠️ CRITICAL STANDARDS COMPLIANCE ⚠️
 *
 * Sign-out control rendered with Material Web buttons.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SignalWatcher } from '@lit-labs/signals';
import { firebaseAuthState, signOut } from '@df/state';
let DfSignOut = class DfSignOut extends SignalWatcher(LitElement) {
    constructor() {
        super();
        this.variant = 'button';
    }
    static { this.styles = css `
    :host {
      display: inline-flex;
      font-family: var(--df-font-family, 'Roboto', sans-serif);
    }
  `; }
    render() {
        const authState = firebaseAuthState.get();
        const isAuthenticated = authState.authState === 'authenticated';
        const isLoading = authState.authState === 'loading';
        if (!isAuthenticated && !isLoading) {
            return nothing;
        }
        const label = isLoading ? 'Signing Out…' : 'Sign Out';
        if (this.variant === 'link') {
            return html `
        <md-text-button @click=${this._handleClick} ?disabled=${isLoading}>
          ${label}
        </md-text-button>
      `;
        }
        return html `
      <md-filled-button @click=${this._handleClick} ?disabled=${isLoading}>
        ${label}
      </md-filled-button>
    `;
    }
    async _handleClick() {
        try {
            await signOut();
            this.dispatchEvent(new CustomEvent('df-sign-out-success', {
                bubbles: true,
                composed: true,
            }));
        }
        catch (error) {
            this.dispatchEvent(new CustomEvent('df-sign-out-error', {
                detail: {
                    error: error instanceof Error ? error.message : 'Sign out failed',
                },
                bubbles: true,
                composed: true,
            }));
        }
    }
};
__decorate([
    property({ type: String })
], DfSignOut.prototype, "variant", void 0);
DfSignOut = __decorate([
    customElement('df-sign-out')
], DfSignOut);
export { DfSignOut };
//# sourceMappingURL=df-sign-out.js.map